import React from 'react';

export const NavigatorContext = React.createContext({
  selectedFamily: 'all',
  setSelectedFamily: () => {},
} as any);

export const NavigatorProvider = ({ children }) => {
  const [selectedFamily, setSelectedFamily] = React.useState('all');
  const value = { selectedFamily, setSelectedFamily };
  return (
    <NavigatorContext.Provider value={value}>
      {children}
    </NavigatorContext.Provider>
  );
};
